import { useQuery } from '@tanstack/react-query';
import type { AgentApiAnalysisFilterOptionsShow } from '@/types/serializers';

/**
 * 分析フィルターオプション（担当者一覧など）を取得するカスタムフック
 * TanStack Query を使用してキャッシュ管理を行う
 */
export default function useFetchAnalysisFilterOptions() {
  return useQuery<AgentApiAnalysisFilterOptionsShow>({
    queryKey: ['/agent/api/analysis/filter_options'],
    queryFn: async () => {
      const response = await fetch('/agent/api/analysis/filter_options.json');
      if (!response.ok) {
        throw new Error('フィルターオプションの取得に失敗しました');
      }
      return response.json() as Promise<AgentApiAnalysisFilterOptionsShow>;
    },
    // フィルターオプションは頻繁に変わらないため staleTime を長めに設定
    staleTime: 5 * 60 * 1000,
  });
}
